export default "__VITE_ASSET__CWjCjOnk__"